import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionContainer } from '../../Other/SectionContainer';
import { ExpandableContent } from 'components/Shared';
import { useScreenSize } from 'components/Layout';
import { useSessionFlag } from 'hooks/useSessionFlag';

import './ProviderBio.scss';

interface ProviderBioProps {
  providerBio: string;
}

const providerBioHtml = `
Dr. John Smith is a licensed professional counsellor with 12 years of experience specializing in cognitive behavioural therapy and anxiety management. He holds a Master's degree in Clinical Mental Health Counselling and is passionate about helping clients navigate life transitions, manage depression, and overcome anxiety disorders.
Fluent in both English and Spanish, John creates a welcoming, non-judgmental environment where clients feel safe exploring their challenges. He integrates evidence-based techniques with a compassionate, client-centred approach to foster meaningful personal growth and lasting change.

Sophie Jack is committed to providing comprehensive, family-centered mental health care that addresses the needs of individuals across the lifespan. She believes in a holistic approach that considers the interconnectedness of personal, relational, and family systems. Sophie is dedicated to supporting neurodivergent individuals and those navigating life's most challenging transitions. Her practice is grounded in compassion, cultural sensitivity, and evidence-based therapeutic approaches that empower clients and families to build stronger, healthier relationships. 
Client Populations Served: Children, adolescents, and adults; couples and families; individuals with neurodivergent profiles; and those experiencing relationship challenges, trauma, or significant life transitions.
`;

const CHAR_LIMITS = {
  desktop: 318,
  mobile: 244
} as const;

export const ProviderBio: FC<ProviderBioProps> = ({ providerBio = "" }) => {
    const { t, ready: translationsReady } = useTranslation('providerprofile', { useSuspense: false });
    const { isMobile } = useScreenSize();
    const useDummyData = useSessionFlag('use-fake-provider-bio');
    const content = useDummyData ? providerBioHtml : providerBio;
    
    return (!translationsReady || !content)
        ? <></>
        : <SectionContainer id="provider_bio_container" title={t('provider_bio__section_title')}>
            <ExpandableContent maxChars={isMobile ? CHAR_LIMITS.mobile : CHAR_LIMITS.desktop}>
              <div dangerouslySetInnerHTML={{ __html: content }}/>
            </ExpandableContent>
        </SectionContainer>
}
